import React, { createContext, useContext } from 'react';

interface SideMenuPageProps {
  onNotificationClick?: () => void;
}

interface HeaderPageProps {
  bellComponent?: React.ReactElement;
  userComponent?: React.ReactElement;
}

interface PagePropsContextValue {
  sideMenu?: SideMenuPageProps;
  header?: HeaderPageProps;
  [key: string]: unknown;
}

const PagePropsContext = createContext<PagePropsContextValue | undefined>(
  undefined,
);

interface PagePropsProviderProps {
  pageProps?: PagePropsContextValue;
  children: React.ReactNode;
}

export const PagePropsProvider = ({
  pageProps,
  children,
}: PagePropsProviderProps) => {
  return (
    <PagePropsContext.Provider value={pageProps}>
      {children}
    </PagePropsContext.Provider>
  );
};

export const usePageProps = () => {
  const context = useContext(PagePropsContext);
  return context;
};

export const useHeaderPageProps = (): HeaderPageProps | undefined => {
  const context = usePageProps();
  return context?.header as HeaderPageProps | undefined;
};

export const useSideMenuPageProps = () => {
  const context = usePageProps();
  return context?.sideMenu as SideMenuPageProps | undefined;
};
